import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import { setSelectedProperties } from "../../features/Properties/store/propertiesSlice";

const PropertiesFilter = () => {
  const dispatch = useDispatch();
  const properties = useSelector((state) => state.properties.properties);
  const selectedProperties = useSelector(
    (state) => state.properties.selectedProperties
  );

  const AllOption = {
    label: "All",
    value: "all",
  };

  const options = [
    AllOption,
    ...properties?.map((item) => {
      return {
        label: item?.name,
        value: item?.id,
      };
    }),
  ];

  const handlePropertyChange = (id) => {
    if (id.includes("all")) {
      const allSelected = selectedProperties.length === properties.length;

      if (allSelected) {
        dispatch(setSelectedProperties([]));
      } else {
        dispatch(setSelectedProperties(properties?.map((item) => item?.id)));
      }
    } else {
      dispatch(setSelectedProperties(id));
    }
  };

  return (
    <Select
      optionFilterProp="label"
      showSearch
      maxTagCount="responsive"
      mode="multiple"
      allowClear
      style={{
        width: "100%",
      }}
      placeholder="Please select"
      defaultValue={[properties[0]?.id]}
      value={selectedProperties}
      onChange={handlePropertyChange}
      options={options}
    />
  );
};

export default PropertiesFilter;
